import { Skeleton } from "@mui/material";

interface ITableCellSkeletonProps {
    animation?: "pulse" | "wave" | false;
    backgroundColor?: string;
}

export const TableCellSkeleton = ({ animation = "pulse", backgroundColor }: ITableCellSkeletonProps) => {
    return (
        <Skeleton variant="rounded" height={20} width="100%" animation={animation} sx={{ margin: 0, ...(backgroundColor && { backgroundColor }) }} />
    );
};
